<template>
<div>
  <b-modal id="modal-sm" size="md" title="Role Permission" v-model="showModal" no-close-on-esc no-close-on-backdrop hide-header-close>
  <div slot="default">
    <div class='alert alert-warning' role='alert' v-if=!succeeded> {{Msg}} <br> Please Contact System Administrator. </div>
    <div class="alert alert-success" role="alert" v-if=succeeded> {{Msg}} </div>
   </div> 
  <div slot="modal-footer" class="w-100">
        <p class="float-left" variant="primary"></p>
         <b-button variant="primary"  size="md"  class="float-right"  @click="showModal=false"> Close </b-button>
      </div>
</b-modal>
 <Subtitle  v-bind:ServiceID="this.AppServiceID">
<template v-slot:header>
<i class="fas fa-user-lock"></i><b>  Manage Role Permission:</b>
</template> 
</Subtitle>  
<Card>
  <CardBody>
    <p>Manage Role Permission is an Administration action. Any change in this section will affect the web application and its access level. All transactions are monitored, logged and reviewed.
    </p>
  </CardBody>
</Card> 

 <form class="card" id="SearchForm">
  <div class="card-header d-flex align-items-center  pl-2" style="height: 2rem; text-align:left;">
        <h5><small class="text-muted"><b><i class="fas fa-search-plus"></i>Search: Service Type  and Role (Required)</b></small></h5>
  </div>
  <div class="form-row p-2">
    <div class="form-group col-sm-2">
      <label for="NewHSN" class="label">Service Type</label>
      <select   v-model="selectService" v-on:change="fillroles($event)" class="form-control form-control-sm" > -->
          <option v-for="option in Services" v-bind:value="option.serviceid" :key="option.serviceid">
            {{ option.service }}
          </option>
        </select>
    </div>
  
    <div class="form-group col-sm-3" v-if="selectService !=''  && selectService !=null">
      <label for="inputEmail4" class="label">Role:</label>
      <div>
        <select v-model="selectRole"  class="form-control form-control-sm" v-on:change="GetTableData($event)">
        <!-- <option disabled value="" selected="selected">Please select one</option> -->
        <option v-for="option in Roles" v-bind:value="{id: option.roleid, text: option.role}" :key="option.roleid">
          {{ option.role }}
        </option>
        </select> 
      </div> 
    </div>
  </div> 
</form> 


  <div class="row no-gutter"> 
    <transition name="slide-fade" >  
    <div class="col-sm-5" v-if="showtable">  
    <div class="mb-2 mt-2">
      <v-client-table  	ref="table" :columns="columns" :data="tableData" :options="options" >
      <div slot="beforeFilter"  class=" mr-3">
        <!-- <div class="checkbox">
          <label><input type="checkbox" v-bind:value="allMarked" value="" v-on:click="toggleAll">
          <span class="cr"><i class="cr-icon fas fa-check"></i></span>All/None
          </label>
        </div> -->

         <!-- <input type="checkbox" v-bind:value="allMarked" v-on:click="toggleAll" class="btn btn-primary form-control">Select All</input>  -->
          <!-- <button type="button" v-bind:value="allMarked" v-on:click="toggleAll" class="btn btn-primary form-control">Select All/None</button> -->
      
      
        </div>
       <div slot="afterFilter"  class="ml-3 "> 
           <button type="button"  v-if="showtable" class="btn BtnClose mb-1" v-on:click="SavePermissionss">Save Permissions</button>
      </div>
      <template slot="id"   slot-scope="props">
        <div class="checkbox">
          <label>
            <input type="checkbox" class="pointer"	@change="unmarkAll()"  :value="props.row.id"	v-model="markedRows">
            <span class="cr"><i class="cr-icon fas fa-check"></i></span> 
          </label>
        </div>
        <!-- <input type="checkbox" class="pointer"	@change="unmarkAll()"  :value="props.row.id"	v-model="markedRows"> -->
      </template>
      </v-client-table>
    </div>
  </div>
 </transition> 
</div>
</div>
</template>
<script>
import {mapGetters} from 'vuex'
import axios from 'axios'
import LayoutDefault from '@/Common/Default/DefaultLayout.vue';
import Card from "@/Common/Card.vue";
import CardBody from "@/Common/CardBody.vue";
import TileNote from "@/Common/TileNote.vue";
import Subtitle from '@/Common/Default/SubTitle.vue';  
export default {
data: function () {
    return {
      AppServiceID:6,
       showModal: false,
       showtable:false,
       succeeded: false,
        Msg:'', 
        selectService: '',
        Services:[],
        selectRole: '',
        Roles:[],
        columns: ['id', 'pagename'],
        tableData: [],
        allMarked:false,
        markedRows:[],       
        options: {
          filterable:[],
          headings: {
            id: 'Grant Permission',
            pagename: 'Page Name',
          },
           texts:{ 
              filter:"", 
          },
          highlightMatches:true,
          orderBy: { ascending:true },      
           perPage:18,
           perPageValues:[20,30,40,50],            
           sortable: ['pagename'],
           pagination: {
            edge: true,
            nav: 'scroll',
            chunk: 18
            },
          }
      }
  }, 
  watch: {
     showtable:  function (val, oldVal) {
       // this.markedRows = val;
      },
  },
  components: {

          Card,
          CardBody,
          TileNote,
          Subtitle
      },
    methods: {
        GoBack(){
            this.$router.push('/DPEBB/MainHome')
        },
         unmarkAll() {
          ////console.log('at change called')
            this.allMarked = false;
            ////console.log(this.markedRows)
          },
          toggleAll() {
            ////console.log('toggle called')
            //this.markedRows = this.allMarked?this.$refs.table.data.map(row=>row.id):[];
             this.markedRows = this.allMarked ? [] : this.$refs.table.data.map(row => row.id);
              this.allMarked = !this.allMarked;
          },
         AddUserPopup(){
            this.showModal = true;
        },
         EditUserPopup(Rowdata){
            //this.showModal = true;
            this.UserData= Rowdata;
            alert(this.UserData.username)
        },
        closeModal() {
          this.isModalVisible = false;
        },
         fillroles(){ 
            var vm = this;
            vm.Roles = [];
            vm.selectRole = '';
            vm.showtable=false;
            var params = new URLSearchParams();
            params.append('ServiceID', this.selectService);
             axios.get('/SaskHealthApi/Security/GetRolesWithDPEBB', { headers: { 'Authorization': 'Bearer ' + localStorage.access_token },params})
             //axios.get('/SaskHealthApi/Codes/GetRoles')
                .then(function (response) {
                    ////console.log(response.data);
                    //alert(vm.Roles)
                    vm.Roles = response.data
                    //alert(vm.Roles)
                    ////console.log(response);
                })
            .catch(function (er) {
                //console.log(er)
            })
        },
        SavePermissionss(){
            var vm = this; 
            var url = "/SaskHealthApi/Security/PostUpdatePermission/"
            var params = {
                "_": Date.now(),
                "PermPageIds": vm.markedRows,
                "ServiceID": vm.selectService,
                "RoleID": vm.selectRole.id
                } 
           axios({
              method: 'post',
              url: url,
              headers: { 'Authorization': 'Bearer ' + vm.$store.getters.GetAccessToken },
              data: params
            }).then(function (response) {
                  //console.log(response)
                  if(response.status ==200)
                  {
                    if(response.data.succeeded)
                    {
                          vm.succeeded = true;
                          vm.Msg="Permission Successfully Saved For " +  vm.selectRole.text+".";  
                          //vm.Msg="<div class='alert alert-warning' role='alert'>"+'Permission Not Saved Successfully Saved For ' +  vm.selectRole.text +"</div>";                                                  
                          vm.showModal=true;
                    }
                    else
                    {
                          vm.succeeded = false;
                          vm.Msg="Warning: Permission Not Successfully Saved For " +  vm.selectRole.text+".";  
                          vm.showModal=true;
                    }
                  }
                })
                .catch(function (er) {
                    //console.log(er)
                }).then(function () {

                }); 
        },
        GetTableData(){
           var vm = this;  
            var params = new URLSearchParams();
            params.append('ServiceID', this.selectService);
            params.append('RoleID', this.selectRole.id);
           // params.append('PermissionPageIds', PermissionPageIds);
            axios.get('/SaskHealthApi/security/RolesPermission?_='+Date.now(), { headers: { 'Authorization': 'Bearer ' + localStorage.access_token },params})
            .then(function (response) {
                  vm.tableData=response.data;
                  //vm.mydata=response.data;
                  vm.showtable =true;
                })
                .catch(function (er) {
                    //console.log(er)
                }).then(function () {

                  vm.markedRows=[];
                   // vm.tableData.push(response.data);
                   for(let i = 0; i <  vm.tableData.length; i++){

                        if(vm.tableData[i].haspermission)
                        {
                          // alert(vm.tableData[i].haspermission)
                            vm.markedRows.push(vm.tableData[i].id);
                        }
                    }

                   // //console.log('at get table' + vm.markedRows)
                }); 
        },
        FillSelect(){
            var vm = this;
             for(let i = 0; i < vm.tableData.lenght; i++){
                  //console.log(vm.tableData.length)
                    if(vm.tableData[i].haspermission)
                    {
                        //console.log(vm.tableData[i].haspermission)
                    }
                  }
        }
    },
     computed:{
    
    },
     created () {
          var vm = this;
          ////console.log('at created' + vm.tableData)
    },

     mounted: function () {
      this.$nextTick(function () {
             var vm = this;
              axios.get('/SaskHealthApi/Codes/GetServices', { headers: { 'Authorization': 'Bearer ' + vm.$store.getters.GetAccessToken  }})
              .then(function (response) {
                  ////console.log(response.data);
                  //alert(vm.Services)
                  vm.Services = response.data
                  //alert(vm.Services)
                  ////console.log(response);
              })
          .catch(function (er) {
              //console.log(er)
          })
          //this. fillroles();
      })
     }
}
</script>
<style scoped>
@import url(//netdna.bootstrapcdn.com/font-awesome/4.2.0/css/font-awesome.css);

/*** basic styles ***/
/* 
body { margin: 20px; }
h1 { font-size: 1.5em; }
label { font-size: 18px; }
container {
  width: 175px;
  margin-left: 20px;
} */

input[type=radio].with-font,
input[type=checkbox].with-font {
    border: 0;
    clip: rect(0 0 0 0);
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    width: 1px;
}

input[type=radio].with-font ~ label:before,
input[type=checkbox].with-font ~ label:before {
    font-family: FontAwesome;
    display: inline-block;
    content: "\f1db";
    letter-spacing: 10px;
    font-size: 1.2em;
    color: #535353;
    width: 1.4em;
}

input[type=radio].with-font:checked ~ label:before,
input[type=checkbox].with-font:checked ~ label:before  {
    content: "\f00c";
    font-size: 1.2em;
    color: darkgreen;
    letter-spacing: 5px;
}
input[type=checkbox].with-font ~ label:before {
    content: "\f096";
}
input[type=checkbox].with-font:checked ~ label:before {
    content: "\f046";
    color: darkgreen;
}
input[type=radio].with-font:focus ~ label:before,
input[type=checkbox].with-font:focus ~ label:before,
input[type=radio].with-font:focus ~ label,
input[type=checkbox].with-font:focus ~ label
{
    color: green;
}

.checkbox label:after {
  content: '';
  display: table;
  clear: both;
}

.checkbox .cr {
  position: relative;
  display: inline-block;
  border: 1px solid #a9a9a9;
  border-radius: .25em;
  width: 1.2em;
  height: 1.2em;
  /* float: left; */
  margin-right: .5em;
}

.checkbox .cr .cr-icon {
  position: absolute;
  font-size: .7em;
  line-height: 0;
  top: 50%;
  left: 15%;
}

.checkbox label input[type="checkbox"] {
  display: none;
}

.checkbox label input[type="checkbox"]+.cr>.cr-icon {
  opacity: 0;
}

.checkbox label input[type="checkbox"]:checked+.cr>.cr-icon {
  opacity: 1;
}

.checkbox label input[type="checkbox"]:disabled+.cr {
  opacity: .5;
}

</style>
